import React from 'react'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Button from '@mui/material/Button';
import {
    ButtonGroup,
} from "@mui/material";
import { decrement, increment } from '../../features/cart/cartSlice';
import { useDispatch } from "react-redux";

export default function IncreaseAndDecrease({ counter }) {
    const dispatch = useDispatch();
    return (
        <div className="row">
            <div className="col-md-3 col-sm-2 col-5 increase">
                <ButtonGroup variant="contained" aria-label="outlined primary button group">

                    <Button
                        style={{
                            backgroundColor: '#c0cb6a',
                            borderColor: 'rgb(192, 203, 106)',
                            borderTopLeftRadius: '.25rem',
                            borderBottomLeftRadius: '.25rem',
                            color: 'white'
                        }}
                        classes={{ root: "bg-1" }}
                        variant='contained'
                        onClick={() => dispatch(decrement())}
                        sx={{ p: 0, height: 38, borderRadius: 0, borderBottom: 0.5 }}>
                        <RemoveCircleOutlineIcon />
                    </Button>
                    <Button style={{
                        backgroundColor: '#c0cb6a',
                        borderColor: 'rgb(192, 203, 106)',
                        color: 'white',
                        fontSize: '25px'
                    }}
                        sx={{ p: 0, height: 38, borderRadius: 0, borderBottom: 0.5 }}
                    >{counter}</Button>
                    <Button
                        style={{
                            backgroundColor: '#c0cb6a',
                            borderColor: 'rgb(192, 203, 106)', borderTopRightRadius: '.25rem', borderBottomRightRadius: '.25rem',
                            color: 'white'
                        }}
                        classes={{ root: "bg-1" }}
                        variant='contained'
                        onClick={() => dispatch(increment())}
                        sx={{
                            p: 0,
                            height: 38,
                            borderRadius: 0,
                            borderTop: 0.5,
                        }}>
                        <AddCircleOutlineIcon />
                    </Button>
                </ButtonGroup>
            </div>
        </div>
    )
}
